var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getAPIMap from "../api_map.js";
import axios from "axios";
import getIP from "../getIP.js";
const IP = getIP();
export function getGlobalConfigNoAuth() {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        var url = IP + getAPIMap("getGlobalConfigNoAuth");
        try {
            let res = yield axios.get(url);
            return (_a = res.data) === null || _a === void 0 ? void 0 : _a.data;
        }
        catch (error) {
            console.error("Failed to fetch no-auth config:", error);
            throw error;
        }
    });
}
export const encryptText = (text) => {
    // const encryptedText = CryptoJS.AES.encrypt(
    //   JSON.stringify(text),
    //   SECRETPASS
    // ).toString();
    // return encryptedText || "";
    return text;
};
export const loginMfaAPI = (param) => __awaiter(void 0, void 0, void 0, function* () {
    localStorage.setItem("email", param.email);
    var url = IP + getAPIMap("loginMfa");
    // eslint-disable-next-line no-useless-catch
    try {
        let response = yield axios.post(url, {
            email: param.email,
            password: encryptText(param.pwd),
        });
        return response;
    }
    catch (err) {
        throw err;
    }
});
export const sendMfaOtp = (token, sub) => __awaiter(void 0, void 0, void 0, function* () {
    var sendotpurl = IP + getAPIMap("sentOTP");
    const body = {
        sid: token,
        uid: sub,
    };
    try {
        const response = yield axios.post(sendotpurl, body);
        console.log("success", response);
        return response;
    }
    catch (err) {
        return err;
    }
});
export const resendMfaOtp = (token, sub) => __awaiter(void 0, void 0, void 0, function* () {
    var sendotpurl = IP + getAPIMap("sentOTP");
    const body = {
        sid: token,
        uid: sub,
    };
    try {
        const response = yield axios.post(sendotpurl, body);
        console.log("success", response);
        return response;
    }
    catch (err) {
        return err;
    }
});
